<!-- @format -->

@if (activeGrants.length > 0) {
  <app-grants-table [grants]="activeGrants"></app-grants-table>
}

@if (cancelledGrants.length > 0) {
  <sis-expandable [variant]="'link'" [level]="level" [title]="'PROFILE.GRANTS.CANCELLED_GRANTS' | translate">
    <ng-template sisExpandableContent>
      <app-grants-table [grants]="cancelledGrants"></app-grants-table>
    </ng-template>
  </sis-expandable>
}
